export const SUPPORT_MEASURE_PROTOCOL_TEXT_MAX_LENGTH = 1000;
export const SUPPORT_MEASURE_DESCRIPTION_MAX_LENGTH = 2000;
export const SUPPORT_MEASURE_COMPLETION_RATING_MIN = 1;
export const SUPPORT_MEASURE_COMPLETION_RATING_MAX = 3;

// compact activity label: up to this many students/competences are listed by name before showing a count
export const MAX_NAMED_ACTIVITIES = 2;
